import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo Api 參數
 */
export interface SendMailOtpReq {
    mail: string;
}

/**
 * @todo Api 回傳值
 */
export interface SendMailOtpResp extends GeneralResp {
    code: number;
    letter: string;
    isInWaitToSendAgain: boolean; // 是否在等待重送(是否處於等候再次發送區間)
    dayLimit: number; // 每日發送次數限制
    times: number; // 當日發送次數
}

/**
 * @todo 發送簡訊驗證碼
 */
const SendMailOtp = (data: SendMailOtpReq): Promise<SendMailOtpResp> => {
    const url = RouteUrlList.API_SendMailOtp.path;
    const config = {
        params: { showOverlay: ApiClient.paramTypeEnum.true, getServiceAlert: ApiClient.paramTypeEnum.true }
    };
    return ApiClient.post(url, data, config).then((res: AxiosResponse<SendMailOtpResp>) => {
        return res.data;
    });
};

export default SendMailOtp;
